<!-- <div class="col-12">
  <h2 class="analista">{{analista}}</h2>
</div> -->
<form [formGroup]="form" class="row">
  <div class="style-input-default column-complete col-12 mb-3">
    <textarea rows="6" placeholder="Observaciones..." formControlName="observacion"></textarea>
  </div>
  <div class=" col-12 flex">
    <div class="opcionCheck">
      <mat-checkbox formControlName="existeProcedencia">Existe Procedencia</mat-checkbox>
    </div>
  </div>
  <div class="col-12 texCenter">
    <mat-radio-group class="checleft" formControlName="reclamosMagneticos" aria-label="Select an option">
      <mat-radio-button class="marginRight" [value]="true">Reclamos de Medios Magnético</mat-radio-button>
      <mat-radio-button class="marginLeft" [value]="false">Reclamos de Medios NO Magnético</mat-radio-button>
    </mat-radio-group>
  </div>
</form>
